import { MediaType } from './types';
import { IDSContentfulMedia } from '@ids/types/contentful';

export const useMediaType = (media?: IDSContentfulMedia): MediaType => {
    if (media?.video?.videoFile) {
        return 'video';
    }

    if (media?.image) {
        return 'image';
    }

    return 'unsupported';
};
